import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-popupview-questions',
  templateUrl: './popupview-questions.component.html',
  styleUrl: './popupview-questions.component.scss'
})
export class PopupviewQuestionsComponent {

  @Input() currentQuestion: any;
  @Output() currentQuestionChange = new EventEmitter<any>(); // Two-way binding
  
    //Network IP or Domain
    staticFileUrl = GlobalConstants.staticFilesURL;

  isAssessment= true;

  draggedProduct: any

  
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  years: number[] = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  // Emit whenever the model changes
  onQuestionChange() {
    this.currentQuestionChange.emit(this.currentQuestion);
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode !== 46 &&
        charCode !== 45 &&
        charCode > 31 &&
        (charCode < 48 || charCode > 57)) ||
      (event.target.value.includes('.') && charCode === 46)
    ) {
      return false;
    }
    return true;
  }

  addOrRemoveImageFromList(question: any, label: string) {
    if (question.meta.value.includes(label)) {
      let index = question.meta.value.indexOf(label);
      question.meta.value.splice(index, 1);
    } else {
      question.meta.value.push(label);
    }
  }

  addRemoveValueInFieldArray(field: any, value: any) {
    if (field.value.includes(value)) {
      field.value = field.value.filter((v: string) => v != value);
      return;
    }
    field.value = [...field.value, value];
  }

  getRankDDValues(field: any, value: any, meta: any) {
    let values: any[] = [];

    meta.fields.forEach((metaField: any, i: number) => {
      if (field.label == metaField.label) {
        metaField.value = value;
      }
      values.push({
        label: (i + 1).toString(),
        value: i + 1,
        disabled: metaField.value == i + 1,
      });
    });

    meta.options = this.isAssessment
      ? values
      : [{ label: '-Select-', value: -1, disabled: false }, ...values];
  }

  getRankDDValues2(question: any): string[] {
    let values: string[] = [];

    for (let i = 1; i < question.meta.fields.length + 1; i++) {
      values.push(i.toString());
    }

    return values;
  }

  dragStart(product: any) {
    this.draggedProduct = product;
  }

  drop(question: any) {
    if (this.draggedProduct) {
      question.meta.orderedFields = [
        ...question.meta.orderedFields,
        this.draggedProduct,
      ];
      question.meta.orderedFields = question.meta.orderedFields.map(
        (field: any, index: number) => {
          return {
            ...field,
            value: String(index + 1),
          };
        }
      );
      question.meta.fields = question.meta.fields.filter(
        (val: any) => val.label != this.draggedProduct.label
      );
      this.draggedProduct = null;
    }
  }

  dragEnd() {
    this.draggedProduct = null;
  }


}
